import React from 'react';
import $ from 'jquery';
import { JarvisWidget, smallBox } from '../../../common';
import ScalerChart from './scaler';
import { connect } from 'react-redux';
import * as Actions from '../NewInboxActions';
import { config } from '../../../config/config';
import Select2 from 'react-select2-wrapper';
import ServerSideDataTable from '../../../common/tables/components/ServerSideDataTable';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import jMoment from 'moment-jalaali';

import Spinner from '../../../common/Spinner/Spinner';
import ProcessInfo from './ProcessInfo';
import TaskInfo from './TaskInfo';
import CaseHistory from './CaseHistory';
import postAuthonticatedJSON from '../../../common/utils/functions/postAuthonticatedJSON';
import getAuthonticatedJSON from '../../../common/utils/functions/getAuthonticatedJSON';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import deleteAuthonticatedJSON from "../../../common/utils/functions/deleteAuthonticatedJSON";

class NewInbox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			proUID: null,
			appUID: null,
			processInfo: null,
			taskInfo: null,
			caseHistory: null,
			activeTab: false,
			loading: false,
			variableList: [],
			refresh: false, // pagination
			filter: '', // pagination
			Users: [],
			startcases: [],
			filteredCases: [],
			AssignTags: [],
			TagsIds: [],
			TagsIdsConst: [],
			Tags: [],
			action: 'todo',
			start: '',
			limit: '',
			SearchBarFilter: '',
			sort: '',
			dir: 'DESC',
			cat_uid: '',
			pro_uid: '',
			search: '',
			dateFrom: '',
			dateTo: '',
			newerThan: '',
			data: [],
			counters: [],
			tags: [],
			AssignedTags: [],
			Tree: [],
			appUidForTag: '',
			startDate :' ',
            endDate : ' ',
            alarmDes :' '
		};
	}
	componentDidMount() {
		let self = this;
		$(function() {
			$('#start_date').persianDatepicker({
				onSelect: function() {

				},
			});
			$('#end_date').persianDatepicker({
				onSelect: function() {

				},
			});
		});
		var coll = document.getElementsByClassName('SearchCollapsible');
		var i;

		for (i = 0; i < coll.length; i++) {
			coll[i].addEventListener('click', function() {
				this.classList.toggle('SearchActive');
				var content = this.nextElementSibling;
				if (content.style.display === 'block') {
					content.style.display = 'none';
				} else {
					content.style.display = 'block';
				}
			});
		}
		this.props.loadScalerData(config.apiServer + 'light/counters');
		this.props.loadTreeCase(config.apiServer + 'cases/start-cases-unread-2');
		this.props.loadTags(config.apiServer + 'tag/tags-list');
		this.getDataServer();

		$('input[type=radio][name=action]').change(function() {
			self.setState({
				action: this.value,
			});
		});
		$('input[type=radio][name=filter]').change(function() {
			self.setState({
				SearchBarFilter: this.value,
			});
		});

		$('.dateTo').change(function() {
			$('.newerThan').val(' ');

			self.setState({
				newerThan: '',
			});
		});
		$('.newerThan').change(function() {
			$('.dateFrom').val('');
			$('.dateTo').val('');

			self.setState({
				newerThan: this.value,
				dateTo: '',
				dateFrom: '',
			});
		});
		$('#searchBox').change(function() {
			self.setState({
				search: this.value,
			});
		});

		$(document).on('dblclick', '.open-case', function() {
			let id = $(this).attr('id');

			self.getCaseOnClicked(id, function(clickedCase) {
				if (clickedCase.action == 'unassigned') {
					postAuthonticatedJSON(
						config.apiServer + 'extrarest/case/' + clickedCase.app_uid + '/claim'
					).then(res => {});
					self.props.history.push('/outlook/detail/' + clickedCase.app_uid + '/' + clickedCase.del_index);
				} else {
					self.props.history.push('/newInbox/detail/' + clickedCase.app_uid + '/' + clickedCase.del_index);
				}
			});
		});
		$(document).on('click', '.visitCase', function() {
			let id = $(this).attr('id');

			self.getCaseOnClicked(id, function(clickedCase) {
				if (clickedCase.action == 'unassigned') {
					postAuthonticatedJSON(
						config.apiServer + 'extrarest/case/' + clickedCase.app_uid + '/claim'
					).then(res => {});
					self.props.history.push('/outlook/detail/' + clickedCase.app_uid + '/' + clickedCase.del_index);
				} else {
					self.props.history.push('/newInbox/detail/' + clickedCase.app_uid + '/' + clickedCase.del_index);
				}
			});
		});

		$(document).delegate('.processMap', 'click', function() {
			let id = $(this).attr('id');

			self.getCaseOnClicked(id, function(clickedCase) {
				if (clickedCase)
					self.props.history.push('/newInbox/processMap/' + clickedCase.app_uid + '/' + clickedCase.pro_uid);
			});
		});

		$(document).delegate('.variable-modal', 'click', function() {
			let id = $(this).attr('id');

			self.showVariables(id);
		});
		$(document).delegate('.tagModal', 'click', function() {
			let id = $(this).attr('id');
			self.getAvailableTags();
			self.setState({
				appUidForTag: $(this).attr('id'),
			});
			self.getSelectedTag($(this).attr('id'));
			$('#tagModal').modal('show');
		});
		$(document).delegate('.alarmModal', 'click', function() {
			let id = $(this).attr('id');
			$('#alarmModal').modal('show');
		});
		$(document).delegate('.caseHistory', 'click', function() {
			let id = $(this).attr('id');

			self.getHistory($(this).attr('id'));
			$('#caseHistoryModal').modal('show');
		});
		$(document).delegate('.processInfo', 'click', function() {
			let id = $(this).attr('id');
			self.getProccessInformation($(this).attr('id'));
			$('#processInfoModal').modal('show');
		});
		$(document).delegate('.taskInfo', 'click', function() {
			let id = $(this).attr('id');
			self.getTaskInformation($(this).attr('id'));
			$('#taskInfoModal').modal('show');
		});
	}

	getCaseOnClicked(id, callback) {
		let item = this.props.messages.filter(x => {
			return parseInt(x.app_uid) === parseInt(id);
		});

		if (item.length > 0) callback(item[0]);
	}

	getHistory = app_uid => {
		this.setState({ loading: true });
		const URL = config.apiServer + 'cases/' + app_uid + '/tasks';

		getAuthonticatedJSON(URL)
			.then(res => {
				res = res.reverse();
				this.setState({
					caseHistory: res,
					loading: false,
				});
			})
			.catch(error => {
				this.handleError(error);
			});
	};

	getProccessInformation = pro_uid => {
		this.setState({ loading: true });
		const URL = config.apiServer + 'processinfo/processinformation?ProUid=' + pro_uid;
		getAuthonticatedJSON(URL)
			.then(res => {
				this.setState({
					processInfo: res,
					loading: false,
				});
			})
			.catch(error => {
				this.handleError(error);
			});
	};

	showVariables = id => {
		let CS = this.props.messages.filter(item => {
			return item.app_uid == id;
		});

		if (CS.length > 0) this.setState({ variableList: CS[0].variables });
		else this.setState({ variableList: [] });

		$('#VariableModal').modal('show');
	};
	getTaskInformation = id => {
		const URL =
			config.apiServer +
			'taskinfo/taskinformation?APP_UID=' +
			id.substring(0, 32) +
			'&TAS_UID=' +
			id.substring(32, 64) +
			'&DEL_INDEX=' +
			id.charAt(64);
		getAuthonticatedJSON(URL)
			.then(res => {
				this.setState({
					taskInfo: res,
					loading: false,
				});
			})
			.catch(error => {
				this.handleError(error);
			});
	};

	handelAssignTags = selected => {
		let forAssign = selected.filter(data => {
			return this.state.TagsIdsConst.indexOf(data) < 0;
		});
		let forUnAssign = this.state.TagsIdsConst.filter(data => {
			return selected.indexOf(data) < 0;
		});

		this.setState({ TagsIds: selected });

		if (forAssign.length > 0) this.assignTag(selected);
		this.filterData();

		if (forUnAssign.length > 0) this.assignTag(selected);
		this.filterData();
	};

	assignTag(tags) {
		let roleID = $('#ROL_UID').val();
		let appUID = this.state.appUID;
		const CS = this.props.messages.filter(item => {
			return item.app_uid == appUID;
		});
		postAuthonticatedJSON(config.apiServer + 'tag', {
			body: JSON.stringify({
				app_uid: this.state.appUidForTag,
				tags: tags,
			}),
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('access_token'),
				'Content-Type': 'application/json',
			},
		}).then(res => {
			smallBox({
				title: this.props.t('Successfully'),
				content: '<i>' + this.props.t('Data has been saved successfully') + '</i>',
				color: '#659265',
				iconSmall: 'fa fa-check fa-2x fadeInRight animated',
				timeout: 4000,
			});
		});
	}

	unAssignTag(unassigned) {
		let roleID = $('#ROL_UID').val();
		try {
			for (let i = 0; i < unassigned.length; i++) {
				let usr_uid = unassigned[i];
				deleteAuthonticatedJSON(config.apiServer + 'group/' + roleID + '/user/' + usr_uid).then(res => {});
			}
			smallBox({
				title: this.props.t('Successfully'),
				content: '<i>' + this.props.t('Data has been saved successfully') + '</i>',
				color: '#659265',
				iconSmall: 'fa fa-check fa-2x fadeInRight animated',
				timeout: 4000,
			});
		} catch (e) {}
	}
	getAvailableTags = () => {
		let self = this;

		getAuthonticatedJSON(config.apiServer + 'tag/tags-list', {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('access_token'),
				'Content-Type': 'application/json',
			},
		}).then(res => {
			let AssignTags = [];
			let AssignTagsids = [];
			Object.values(res).map(item => {
				AssignTags.push({
					value: item.ID,
					label: item.TITLE,
				});
				AssignTagsids.push(item.ID);
			});
			self.state.Tags.map(item => {
				AssignTags.push({
					value: item.ID,
					label: item.TITLE,
				});
			});
			self.setState({ AssignTags: AssignTags });
		});
	};

	getSelectedTag = id => {
		getAuthonticatedJSON(config.apiServer + 'tag/assigned-tags/' + id, {
			headers: {
				Authorization: 'Bearer ' + localStorage.getItem('access_token'),
				'Content-Type': 'application/json',
			},
		}).then(res => {
			let a = [];
			Object.values(res).map(d => {
				a.push(d.ID);
			});

			this.setState({ TagsIds: a, TagsIdsConst: a });
		});
	};

	getDataServer = (
		action,
		start,
		limit,
		filter,
		sort,
		dir,
		cat_uid,
		pro_uid,
		search,
		dateFrom,
		dateTo,
		newerThan,
		current
	) => {
		this.props.outlookPaginationServer(
			action,
			start,
			limit,
			filter,
			sort,
			dir,
			cat_uid,
			pro_uid,
			search,
			dateFrom,
			dateTo,
			newerThan,
			current
		);
	};
	actionChange = e => {
		this.getDataServer(
			e.target.value,
			this.props.pagination.start,
			this.props.pagination.limit,
			this.state.SearchBarFilter,
			this.state.sort,
			this.state.dir,
			this.state.cat_uid,
			this.state.pro_uid,
			this.state.search,
			this.state.dateFrom,
			this.state.dateTo,
			this.state.newerThan
		);
	};
	filterByDraft = () => {
		this.getDataServer(
			'draft',
			this.props.pagination.start,
			this.props.pagination.limit,
			this.state.SearchBarFilter,
			this.state.sort,
			this.state.dir,
			this.state.cat_uid,
			this.state.pro_uid,
			this.state.search,
			this.state.dateFrom,
			this.state.dateTo,
			this.state.newerThan
		);
	};

	filterByParticipated = () => {
		this.getDataServer(
			'sent',
			this.props.pagination.start,
			this.props.pagination.limit,
			this.state.SearchBarFilter,
			this.state.sort,
			this.state.dir,
			this.state.cat_uid,
			this.state.pro_uid,
			this.state.search,
			this.state.dateFrom,
			this.state.dateTo,
			this.state.newerThan
		);
	};

	filterByUnassigned = () => {
		this.getDataServer(
			'unassigned',
			this.props.pagination.start,
			this.props.pagination.limit,
			this.state.SearchBarFilter,
			this.state.sort,
			this.state.dir,
			this.state.cat_uid,
			this.state.pro_uid,
			this.state.search,
			this.state.dateFrom,
			this.state.dateTo,
			this.state.newerThan
		);
	};

	filterBytoDo = () => {
		this.getDataServer(
			'todo',
			this.props.pagination.start,
			this.props.pagination.limit,
			this.state.SearchBarFilter,
			this.state.sort,
			this.state.dir,
			this.state.cat_uid,
			this.state.pro_uid,
			this.state.search,
			this.state.dateFrom,
			this.state.dateTo,
			this.state.newerThan
		);
	};

	filterChange = e => {
		this.getDataServer(
			this.state.action,
			this.props.pagination.start,
			this.props.pagination.limit,
			e.target.value,
			this.state.sort,
			this.state.dir,
			this.state.cat_uid,
			this.state.pro_uid,
			this.state.search,
			this.state.dateFrom,
			this.state.dateTo,
			this.state.newerThan
		);
	};

	newerThanChange = e => {
		this.getDataServer(
			this.state.action,
			this.props.pagination.start,
			this.props.pagination.limit,
			this.state.SearchBarFilter,
			this.state.sort,
			this.state.dir,
			this.state.cat_uid,
			this.state.pro_uid,
			this.state.search,
			this.state.dateFrom,
			this.state.dateTo,
			e.target.value
		);
	};
	processChange = e => {
		this.getDataServer(
			this.state.action,
			this.props.pagination.start,
			this.props.pagination.limit,
			this.state.SearchBarFilter,
			this.state.sort,
			this.state.dir,
			this.state.cat_uid,
			e.target.value.substring(0, 32),
			this.state.search,
			this.state.dateFrom,
			this.state.dateTo,
			this.state.newerThan
		);
	};

	resetData = e => {
		this.getDataServer();
	};
	filterData = e => {
		// let filter = document.getElementById('searchBox').value;
		this.getDataServer(
			this.state.action,
			this.props.pagination.start,
			this.props.pagination.limit,
			this.state.SearchBarFilter,
			this.state.sort,
			this.state.dir,
			this.state.cat_uid,
			this.state.pro_uid,
			this.state.search,
			this.state.dateFrom,
			this.state.dateTo,
			this.state.newerThan
		);
	};
	dateFromChange = (unix, formatted) => {
	};
	dateToChange = (unix, formatted) => {
	};

	render() {
		let searchBar = (
			<div style={{ padding: 10 }}>
				<div className="row">
					<div className="col col-md-6 rightSide">
						<div className="row rightTop">
							<div className="col col-md-8">
								<input
									type="radio"
									name="action"
									className="radioInput"
									value="todo"
									onChange={this.actionChange}
								/>
								<label className="radioLabel">دریافت شده</label>
								<input
									type="radio"
									name="action"
									className="radioInput"
									value="sent"
									onChange={this.actionChange}
								/>
								<label className="radioLabel">ارسال شده</label>
								<input
									onChange={this.actionChange}
									type="radio"
									name="action"
									className="radioInput"
									value="unassigned"
								/>
								<label className="radioLabel"> اختصاص نیافته</label>
								<input
									type="radio"
									name="action"
									className="radioInput"
									value="draft"
									onChange={this.actionChange}
								/>
								<label className="radioLabel">پیش نویس</label>
							</div>
							<div className="col col-md-4">
								<input
									type="radio"
									name="filter"
									className="radioInput"
									value="read"
									onChange={this.filterChange}
								/>

								<label className="radioLabel">خوانده شده</label>
								<input
									onChange={this.filterChange}
									type="radio"
									name="filter"
									className="radioInput"
									value="unread"
								/>
								<label className="radioLabel">خوانده نشده</label>
							</div>
						</div>
						<div className="row rigtBottom">
							<div className="col col-md-8" style={{ display: 'flex' }}>
								<label style={{ marginLeft: 10 }}> از تاریخ</label>
								<input
									placeholder="انتخاب تاریخ"
									format="jYYYY/jMM/jDD"
									onChange={this.dateFromChange}
									id="datePicker"
									className="dateFrom"
								/>

								<label style={{ marginLeft: 10, marginRight: 10 }}>تا تاریخ</label>
								<input
									placeholder="انتخاب تاریخ"
									format="jYYYY/jMM/jDD"
									onChange={this.dateToChange}
									id="datePicker"
									className="dateTo"
								/>
							</div>
							<div className="col col-md-4">
								<select className="newerThan" onChange={this.newerThanChange}>
									<option value=" ">انتخاب بازه زمانی</option>
									<option value="-1 Days">۱ روز اخیر</option>
									<option value="-1 Weeks">۱ هفته اخیر</option>
									<option value="-1 Months"> ۱ ماه اخیر</option>
									<option value="-3 Months"> ۳ ماه اخیر</option>
									<option value="-6 Months"> ۶ ماه اخیر</option>
									<option value="-9 Months"> ۹ ماه اخیر</option>
									<option value="-1 Years">۱ سال اخیر</option>
								</select>
							</div>
						</div>
					</div>
					<div className="col col-md-6 leftSide">
						<div className="row leftTop">
							<div className="col col-md-5">
								<span>الویت زمانی </span>
								<label className="checkboxLabel">
									<div className="checkboxGreen"></div>
								</label>
								<input className="checkboxInput" type="checkbox" value="green" />

								<label className="checkboxLabel">
									<div className="checkboxYellow"></div>
								</label>
								<input className="checkboxInput" type="checkbox" value="yellow" />

								<label className="checkboxLabel">
									<div className="checkboxRed"></div>
								</label>
								<input className="checkboxInput" type="checkbox" value="red" />
							</div>
							<div className="col col-md-7">
								<div className="row">
									<div className="col col-md-4">
										<label>انتخاب برچسپ</label>
									</div>

									<div className="col col-md-8">
										<Select2
											multiple
											data={this.props.tags.map(tag => {
												return { text: tag.TITLE, id: tag.ID, key: tag.ID };
											})}
											options={{
												placeholder: 'search by tags',
											}}
										/>
									</div>
								</div>
							</div>
						</div>

						<div className="row leftBottom">
							<div className="search">
								<select
									className="processFilter"
									onChange={this.processChange}
									style={{ width: '24%' }}
								>
									<option value="">جستجو براساس فرایند</option>
									{this.props.treeCase.map(item => {
										return (
											<option key={item.value} value={item.value}>
												{item.name}
											</option>
										);
									})}
								</select>

								<input type="text" className="searchTerm" id="searchBox" placeholder="جستجو ..." />
								<button className="searchButton" onClick={this.filterData}>
									<i className="fa fa-search"></i>
								</button>
								<button className="resetBtn" onClick={this.resetData}>
									<i className="fa fa-refresh resetIcon"></i>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
		let dataRows = null;
		if (this.props.loading) {
			dataRows = <Spinner />;
		} else {
			if (this.props.messages.length > 0) {
				var tmp = [];
				this.props.messages.map((user, index) => {
					tmp.push(this.getTableRow(user, index));
				});

				dataRows = (
					<ServerSideDataTable
						url={this.props.url}
						refresh={this.state.refresh}
						filter={this.state.filter}
						getDataList={(
							action,
							start,
							limit,
							filter,
							sort,
							dir,
							cat_uid,
							pro_uid,
							search,
							dateFrom,
							dateTo,
							newerThan,
							current
						) =>
							this.getDataServer(
								action,
								start,
								limit,
								filter,
								sort,
								dir,
								cat_uid,
								pro_uid,
								search,
								dateFrom,
								dateTo,
								newerThan,
								current
							)
						}
						action={this.state.action}
						start={this.props.pagination.start}
						limit={this.props.pagination.limit}
						sort={this.state.sort}
						dir={this.state.dir}
						cat_uid={this.state.cat_uid}
						pro_uid={this.state.pro_uid}
						search={this.state.search}
						dateFrom={this.state.dateFrom}
						dateTo={this.state.dateTo}
						newerThan={this.state.newerThan}
						pagination={this.props.pagination}
						data={this.props.messages}
					>
						<thead>
							<tr role="row"></tr>
							<tr role="row">
								{config.inboxCols['Activity'] == 0 ? null : (
									<th
										data-hide="phone"
										className="sorting_asc"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										aria-sort="ascending"
										width={config.inboxCols['Activity'] + '%'}
									>
										{this.props.t('Activity')}
									</th>
								)}

								{config.inboxCols['Status'] == 0 ? null : (
									<th
										data-classname="expand"
										className="expand sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['Status'] + '%'}
									>
										{this.props.t('وضعیت')}
									</th>
								)}

								{config.inboxCols['ProcessNumber'] == 0 ? null : (
									<th
										data-classname="expand"
										className="expand sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['ProcessNumber'] + '%'}
									>
										{this.props.t('شماره فرایند')}
									</th>
								)}

								{config.inboxCols['ReciveDate'] == 0 ? null : (
									<th
										data-hide="phone"
										className="sorting"
										abindex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['ReciveDate'] + '%'}
									>
										{this.props.t('RECEIVE DATE')}
									</th>
								)}
								{config.inboxCols['DueDate'] == 0 ? null : (
									<th
										data-hide="phone"
										className="sorting"
										abindex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['DueDate'] + '%'}
									>
										{this.props.t('مهلت اجرا')}
									</th>
								)}

								{/* <th
									className="sorting"
									tabIndex="0"
									aria-controls="DataTables_Table_7"
									rowSpan="1"
									colSpan="1"
								>
									{this.props.t('ارسال')}
                                </th> */}

								{config.inboxCols['PreviousUser'] == 0 ? null : (
									<th
										data-hide="phone,tablet"
										className="sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['PreviousUser'] + '%'}
									>
										{this.props.t('Previous User')}
									</th>
								)}

								{config.inboxCols['SelectedVariable'] == 0 ? null : (
									<th
										data-hide="phone,tablet"
										className="sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width="10%"
										width={config.inboxCols['SelectedVariable'] + '%'}
									>
										{this.props.t('Selected Variable')}
									</th>
								)}

								{config.inboxCols['ShowButton'] == 0 ? null : (
									<th
										data-hide="phone,tablet"
										className="sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['ShowButton'] + '%'}
									>
										مشاهده
									</th>
								)}
								{config.inboxCols['ActionButton'] == 0 ? null : (
									<th
										data-hide="phone,tablet"
										className="sorting"
										tabIndex="0"
										aria-controls="DataTables_Table_7"
										rowSpan="1"
										colSpan="1"
										width={config.inboxCols['ActionButton'] + '%'}
									>
										عملیات
									</th>
								)}
							</tr>
						</thead>
						<tbody>{tmp}</tbody>
					</ServerSideDataTable>
				);

				// setTimeout(() => {
				//     document.getElementById('searchBox').value = this.props.pagination.filter;
				// }, 500);
			} else {
				dataRows = (
					<div className="text-center" style={{ margin: 30 }}>
						<b>{this.props.t('Dont Exists Information For Show')}</b>
					</div>
				);
			}
		}

		let data = this.props.messages;
		var variables = (
			<table className="table table-bordered">
				<tbody>
					<tr>
						<td className="center"> {this.props.t('Not Value')}</td>
					</tr>
				</tbody>
			</table>
		);

		if (this.state.variableList != null && this.state.variableList.length > 0)
			variables = (
				<div>
					<table className="table table-bordered">
						<tbody>
							<tr>
								<td> {this.props.t('Key')}</td>
								<td> {this.props.t('Value')} </td>
							</tr>
							{this.state.variableList.map(variable => {
								if (!variable.var_label && !variable.var_name) {
									return (
										<tr>
											<td>{variable.var_uid}</td>
											<td>وارد نشده</td>
										</tr>
									);
								} else {
									return (
										<tr>
											<td>
												{variable.var_label === '' ? variable.var_name : variable.var_label}
											</td>
											<td>{variable.var_value}</td>
										</tr>
									);
								}
							})}
						</tbody>
					</table>
				</div>
			);

		let processInfo = <Spinner />;
		if (this.state.loading) processInfo = <Spinner />;
		else if (this.state.processInfo != null) processInfo = <ProcessInfo processInfo={this.state.processInfo} />;

		let taskInfo = null;
		if (this.state.loading) taskInfo = <Spinner />;
		else if (this.state.taskInfo != null) taskInfo = <TaskInfo taskInfo={this.state.taskInfo} />;

		let caseHistory = null;
		if (this.state.loading) caseHistory = <Spinner />;
		else if (this.state.caseHistory != null) caseHistory = <CaseHistory caseHistories={this.state.caseHistory} />;

		return (
			<div>
				{config.showScalerBlueChart ? (
					<div className="row sMain">
						<div className="col-md-3 card" onClick={this.filterBytoDo}>
							<ScalerChart
								title={this.props.t('دریافت شده')}
								value={this.props.scalerData.toDo}
								Cstyle="avgcard"
							/>
						</div>
						<div className="col-md-3 card" onClick={this.filterByParticipated}>
							<ScalerChart
								title={this.props.t('ارسال شده')}
								value={this.props.scalerData.participated}
								Cstyle="avgcard"
							/>
						</div>
						<div className="col-md-3 card" onClick={this.filterByUnassigned}>
							<ScalerChart
								title={this.props.t('unassigned')}
								value={this.props.scalerData.unassigned}
								Cstyle="avgcard"
							/>
						</div>
						<div className="col-md-3 card" onClick={this.filterByDraft}>
							<ScalerChart
								title={this.props.t('draft')}
								value={this.props.scalerData.draft}
								Cstyle="avgcard"
							/>
						</div>
					</div>
				) : null}

				{config.SearchCollapsible ? (
					<div>
						{' '}
						<button type="button" className="SearchCollapsible">
							{' '}
							<div>
								{' '}
								جستجوی پیشرفته <i className="fa fa-search"></i>
							</div>
						</button>{' '}
						<div className="content">{searchBar}</div>{' '}
					</div>
				) : (
					<div>{searchBar}</div>
				)}
				<div className="table-wrap custom-scroll">
					<JarvisWidget
						togglebutton={false}
						editbutton={false}
						colorbutton={false}
						deletebutton={false}
						fullscreenbutton={true}
					>
						<header>
							<nav className="inbox_header_item_bx">
								<a className="btn btn_inbox">
									<i className="fa fa-inbox"></i>کارتابل
								</a>
							</nav>
						</header>
						<div id="inbox-content" className="inbox-body1 no-content-padding1 no-padding">
							<div className="col-md-12 border-box">
								<div className="margin-top-10">
									<div className="table-wrap custom-scroll">{dataRows}</div>
								</div>
							</div>
						</div>
						<a id="compose-mail-mini" className="btn btn-primary pull-right hidden-desktop visible-tablet">
							<strong>
								<i className="fa fa-file fa-lg" />
							</strong>
						</a>
					</JarvisWidget>
				</div>

				<div
					className="modal fade"
					id="caseHistoryModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby="ServiceModalLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="ServiceModalLabel">
									{this.props.t('تاریخچه')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">
												<div className="tab-pane active" id="tab_default_4">
													{caseHistory}
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>

				<div
					className="modal fade"
					id="processInfoModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby="ServiceModalLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="ServiceModalLabel">
									{this.props.t('اطلاعات فرایند')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">
												<div className="tab-pane active" id="tab_default_4">
													{processInfo}
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>

				<div
					className="modal fade"
					id="taskInfoModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby="ServiceModalLabel"
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="ServiceModalLabel">
									{this.props.t('اطلاعات وظیفه')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">
												<div className="tab-pane active" id="tab_default_4">
													{taskInfo}
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>

				<div
					className="modal fade"
					id="alarmModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby=""
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="">
									{this.props.t(' ثبت آلارم')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">
												<div className="alarmMain">
													<div className="row">
														<div className="col-md-6">
															<label style={{ margin: 10 }}>تاریخ آغاز </label>
															<input className="form-control" id="start_date" />
														</div>
														<div className="col-md-6">
															<label style={{ margin: 10 }}>تاریخ پایان </label>

															<input className="form-control" id="end_date" />
														</div>
														<div
															className="form-group"
															style={{ margin: 10, paddingTop: 70 }}
														>
															<label> متن آلارم</label>
															<textarea
																className="form-control"
																rows="3"
																onChange={this.onAlarmDesChange}
															></textarea>
														</div>
														<div className="col-md-12" style={{ marginTop: 30 }}>
															<button
																className="btn btn-primary btn-lg btn-block"
																// onClick={this.setAlarm}
															>
																تنظیم
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>

				<div
					className="modal fade"
					id="tagModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby=""
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="">
									{this.props.t(' لیست تگ ها')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">
												<DualListBox
													canFilter
													filterCallback={(option, filterInput) => {
														if (filterInput === '') {
															return true;
														}

														return new RegExp(filterInput, 'i').test(option.label);
													}}
													filterPlaceholder={this.props.t('Search')}
													options={this.state.AssignTags}
													selected={this.state.TagsIds}
													onChange={this.handelAssignTags}
												/>
											</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>

				<div
					className="modal fade"
					id="VariableModal"
					tabIndex="-1"
					role="dialog"
					aria-labelledby=""
					aria-hidden="true"
				>
					<div className="modal-dialog" style={{ width: '65%' }}>
						<div className="modal-content">
							<div className="modal-header">
								<button type="button" className="close" data-dismiss="modal" aria-hidden="true">
									&times;
								</button>
								<h4 className="modal-title" style={{ display: 'inline-block' }} id="">
									{this.props.t('فیلد های منتخب')}
								</h4>
							</div>
							<div className="">
								<form action="" className="smart-form" id="service-form" method="post">
									<div className="tabbable-panel">
										<div className="tabbable-line" id="tabs">
											<div className="tab-content add_service_modal_bx">{variables}</div>
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn_inbox btn_datatable" data-dismiss="modal">
									<i className="fa fa-window-close "></i>
									{this.props.t('Close')}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
	getTableRow = item => {
		let filter = null;
		if (item.filter === '') {
			filter = '- -';
		} else {
			switch (item.filter) {
				case 'read':
					filter = 'خوانده شده';
					break;
				case 'unread':
					filter = 'خوانده نشده';
					break;
				default:
					filter = '- -';
			}
		}
		let action = null;
		if (item.action == null) {
			action = 'گردش کار';
		} else {
			switch (item.action) {
				case 'draft':
					action = 'پیش نویس';
					break;
				case 'unassigned':
					action = 'اختصاص نیافته';
					break;
				case 'sent':
					action = 'ارسال شده';
					break;
				case 'todo':
				case 'inbox':
					action = 'دریافت شده';
					break;
				default:
					action = 'گردش کار';
			}
		}
		let t = item.tags;
		let tags = Object.values(t);
		let tagArr = [];
		// <span class="badge badge-pill badge-primary">Primary</span>

		tags.map(t =>
			tagArr.push(
				<div className="badge badge-pill" style={{ background: t.COLOR }}>
					{t.TITLE}
				</div>
			)
		);
		let init_date = jMoment(item.app_update_date).format('jYYYY/jMM/jDD');
		let init_time = jMoment(item.app_update_date).format('HH:mm:ss');
		let due_date = jMoment(item.del_task_due_date).format('jYYYY/jMM/jDD');
		let due_time = jMoment(item.del_task_due_date).format('HH:mm:ss');

		let color_due = null;
		if (item.due_date_status == 'red') {
			color_due = <div className="color_due" style={{ background: 'red' }}></div>;
		} else if (item.due_date_status == 'green') {
			color_due = <div className="color_due" style={{ background: 'green' }}></div>;
		} else if (item.due_date_status == 'yellow') {
			color_due = <div className="color_due" style={{ background: 'yellow' }}></div>;
		}
		let selected = null;
		if (item.default_variable)
			if (item.del_init_date != null) {
				if (item.default_variable.var_label) {
					selected = item.default_variable.var_label + ' : ' + item.default_variable.var_value;
				} else if (item.default_variable.var_name) {
					selected = item.default_variable.var_name + item.default_variable.var_value;
				} else selected = item.default_variable.var_uid;
			} else {
				if (item.default_variable.var_label) {
					selected = item.default_variable.var_label + item.default_variable.var_value;
				} else if (item.default_variable.var_name) {
					selected = item.default_variable.var_name + item.default_variable.var_value;
				} else {
					selected = item.default_variable.var_uid;
				}
			}
		else if (item.del_init_date != null) {
			selected = this.props.t('Dont Selected');
		} else {
			this.props.t('Dont Selected');
		}

		return (
			// <tr role="row" className="odd open-case" key={item.app_uid} id={item.app_uid}>
			// 	<td id={item.pro_uid} className="hidden clicked-item row-controller">
			// 		<input type="text" value={item.usr_uid} />
			// 	</td>
			// 	<td id={item.pro_uid} className="sorting_1 clicked-item  row-controller" tabIndex="0">
			// 		<div className="row">
			// 			<div className="col col-md-2">{color_due}</div>
			// 			<div className="col col-md-10 pTitle">
			// 				{item.app_pro_title}(<small className="text-muted">{item.app_tas_title}</small>)
			// 			</div>
			// 		</div>

			// 		{tagArr.map(t => {
			// 			return (
			// 				<div className={t.props.className} style={{ background: t.props.style.background }}>
			// 					{t.props.children}
			// 				</div>
			// 			);
			// 		})}
			// 	</td>
			// 	<td id={item.pro_uid} className=" expand clicked-item row-controller">
			// 		{action}
			// 		<hr />
			// 		{filter}
			// 	</td>
			// 	<td id={item.pro_uid} className=" expand clicked-item row-controller">
			// 		{item.app_number}
			// 	</td>
			// 	<td id={item.pro_uid} className="clicked-item row-controller">
			// 		<span className="clicked-item  ">
			// 			{init_date}
			// 			<br /> {init_time}
			// 		</span>
			// 	</td>
			// 	<td id={item.pro_uid} className="clicked-item row-controller">
			// 		<span className="clicked-item  ">
			// 			{due_date}
			// 			<br /> {due_time}
			// 		</span>
			// 	</td>

			// 	<td id={item.pro_uid} className="clicked-item  row-controller">
			// 		{item.previous_user == '' ? '-' : item.previous_user}
			// 	</td>
			// 	<td id={item.app_uid} className="clicked-item  row-controller variable-modal">
			// 		{selected}
			// 	</td>

			// 	<td>
			// 		<div className="dropdown">
			// 			<button className="dropbtn">عملیات</button>
			// 			<div className="dropdown-content">
			// 				<a className="processMap" id={item.app_uid}>
			// 					نقشه فرایند
			// 				</a>
			// 				<a className="caseHistory" id={item.app_uid}>
			// 					تاریخچه
			// 				</a>
			// 				<a className="processInfo" id={item.pro_uid}>
			// 					اطلاعات فرایند
			// 				</a>
			// 				<a className="taskInfo" id={item.app_uid + item.tas_uid + item.del_index}>
			// 					اطلاعات وظیفه
			// 				</a>
			// 				<a className="tagModal" id={item.app_uid}>
			// 					اختصاص برچسپ
			// 				</a>
			// 				<a className="alarmModal" id={item.app_uid}>
			// 					ثبت آلارم
			// 				</a>
			// 			</div>
			// 		</div>
			// 	</td>
			// </tr>
			<tr role="row" className="odd open-case" key={item.app_uid} id={item.app_uid}>
				<td id={item.pro_uid} className="hidden clicked-item row-controller">
					<input type="text" defaultValue={item.usr_uid} />
				</td>
				{config.inboxCols['Activity'] == 0 ? null : (
					<td id={item.pro_uid} className="sorting_1 clicked-item  row-controller" tabIndex="0">
						<div className="row">
							{/* <div className="col col-md-2">{color_due}</div> */}
							{/* change title col-md-10 to 12  */}
							<div className="col col-md-12 pTitle">
								{item.app_pro_title}(<small className="text-muted">{item.app_tas_title}</small>)
							</div>
						</div>

						{tagArr.map(t => {
							return (
								<div className={t.props.className} style={{ background: t.props.style.background }}>
									{t.props.children}
								</div>
							);
						})}
					</td>
				)}
				{config.inboxCols['Status'] == 0 ? null : (
					<td id={item.pro_uid} className=" expand clicked-item row-controller">
						{action}
						<hr />
						{filter}
					</td>
				)}

				{config.inboxCols['ProcessNumber'] == 0 ? null : (
					<td id={item.pro_uid} className=" expand clicked-item row-controller">
						{item.app_number}
					</td>
				)}
				{config.inboxCols['ReciveDate'] == 0 ? null : (
					<td id={item.pro_uid} className="clicked-item row-controller">
						<span className="clicked-item  ">
							{init_date}
							<br /> {init_time}
						</span>
					</td>
				)}

				{config.inboxCols['DueDate'] == 0 ? null : (
					<td id={item.pro_uid} className="clicked-item row-controller">
						<span className="clicked-item  ">
							{due_date}
							<br /> {due_time}
						</span>
					</td>
				)}
				{config.inboxCols['PreviousUser'] == 0 ? null : (
					<td id={item.pro_uid} className="clicked-item  row-controller">
						{item.previous_user == '' ? '-' : item.previous_user}
					</td>
				)}

				{config.inboxCols['SelectedVariable'] == 0 ? null : (
					<td id={item.app_uid} className="clicked-item  row-controller variable-modal">
						{selected}
					</td>
				)}

				{config.inboxCols['ShowButton'] == 0 ? null : (
					<td>
						<button className="visitbtn visitCase" id={item.app_uid}>
							مشاهده
						</button>
					</td>
				)}

				{config.inboxCols['ActionButton'] == 0 ? null : (
						<td>
							<div className="dropdown">
								<button className="dropbtn">عملیات</button>
								<div className="dropdown-content">
									<a className="processMap" id={item.app_uid}>
										نقشه فرایند
									</a>
									<a className="caseHistory" id={item.app_uid}>
										تاریخچه
									</a>
									<a className="processInfo" id={item.pro_uid}>
										اطلاعات فرایند
									</a>
									<a className="taskInfo" id={item.app_uid + item.tas_uid + item.del_index}>
										اطلاعات وظیفه
									</a>
									<a className="tagModal" id={item.app_uid}>
										اختصاص برچسپ
									</a>
									<a className="alarmModal" id={item.app_uid}>
										ثبت آلارم
									</a>
								</div>
							</div>
						</td>
				)}
			</tr>
		);
	};
}
export default compose(
	withTranslation(),
	connect(state => state.newInbox, Actions)
)(NewInbox);
